import { SelectListItem } from './select-property'

export const Options_TimeFormat: SelectListItem[] = [
    { value: "0", text: "yyyyMMddHHmmss" },
    { value: "1", text: "yyyyMMdd" }
];